// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AlertRuleListQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  serverId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type AlertRuleListQuery = {
  __typename?: "GraphqlQuery";
  getAlertRules: Array<{
    __typename?: "AlertRule";
    id: string;
    name: string;
    checkKinds: Array<string>;
    server?: { __typename?: "Server"; humanId: string; name: string } | null;
    destinations: Array<{
      __typename?: "AlertDestination";
      id: string;
      name: string;
    }>;
  }>;
};

export const AlertRuleListDocument = gql`
  query AlertRuleList($organizationSlug: ID!, $serverId: ID) {
    getAlertRules(organizationSlug: $organizationSlug, serverId: $serverId) {
      id
      name
      server {
        humanId
        name
      }
      checkKinds
      destinations {
        id
        name
      }
    }
  }
`;

/**
 * __useAlertRuleListQuery__
 *
 * To run a query within a React component, call `useAlertRuleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertRuleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertRuleListQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useAlertRuleListQuery(
  baseOptions: Apollo.QueryHookOptions<
    AlertRuleListQuery,
    AlertRuleListQueryVariables
  > &
    (
      | { variables: AlertRuleListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AlertRuleListQuery, AlertRuleListQueryVariables>(
    AlertRuleListDocument,
    options,
  );
}
export function useAlertRuleListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertRuleListQuery,
    AlertRuleListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AlertRuleListQuery, AlertRuleListQueryVariables>(
    AlertRuleListDocument,
    options,
  );
}
// @ts-ignore
export function useAlertRuleListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AlertRuleListQuery,
    AlertRuleListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AlertRuleListQuery,
  AlertRuleListQueryVariables
>;
export function useAlertRuleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertRuleListQuery,
        AlertRuleListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AlertRuleListQuery | undefined,
  AlertRuleListQueryVariables
>;
export function useAlertRuleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertRuleListQuery,
        AlertRuleListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AlertRuleListQuery,
    AlertRuleListQueryVariables
  >(AlertRuleListDocument, options);
}
export type AlertRuleListQueryHookResult = ReturnType<
  typeof useAlertRuleListQuery
>;
export type AlertRuleListLazyQueryHookResult = ReturnType<
  typeof useAlertRuleListLazyQuery
>;
export type AlertRuleListSuspenseQueryHookResult = ReturnType<
  typeof useAlertRuleListSuspenseQuery
>;
export type AlertRuleListQueryResult = Apollo.QueryResult<
  AlertRuleListQuery,
  AlertRuleListQueryVariables
>;
